window.createPaymentIntent = function(stripe, clientSecret, redirectURL) {
  const appearance = {
    theme: 'stripe',
    rules: {
      '.Input': {
        colorBackground: '#fff',
        border: '2px solid #cccccc',
        boxShadow: '0px 0px 7px 0px rgba(0,0,0,0.05)',
        borderRadius: '0px'
      },
      '.Input:hover': {
        border: '2px solid #c5f2f4',
        boxShadow: '0px 0px 7px 0px rgba(0,0,0,0.05)'
      }
    }
  };

  const elements = stripe.elements({
    clientSecret: clientSecret,
    appearance: appearance
  });

  let addressElement = elements.create('address', {
    mode: "billing",
    autocomplete: {
      mode: "automatic"
    },
    fields: {
      firstName: 'always',
      lastName: 'always',
      address: 'always'
    },
    validation: {
      firstName: {
        required: 'always'
      },
      lastName: {
        required: 'always'
      },
      address: {
        line1: {
          required: 'always'
        },
        line2: {
          required: 'always'
        },
        city: {
          required: 'always'
        },
        state: {
          required: 'always'
        },
        postal_code: {
          required: 'always'
        },
        country: {
          required: 'always'
        }
      }
    },
    display: {
      name: 'split'
    }
  });

  let paymentElement = elements.create('payment');

  addressElement.mount("#address-element");
  paymentElement.mount("#payment-element");

  const form = document.querySelector("#payment-form");
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    document.getElementsByClassName('payment-overlay')[0].style.display = "flex";
    const {error} = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}${redirectURL}`
      }
    })
    if (error) {
      document.getElementsByClassName('payment-overlay')[0].style.display = "none";
      const messageContainer = document.querySelector('#error-message');
      messageContainer.textContent = error.message;
    }
  })
}
